import React from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../common/Modal';
import Button from '../common/Button';

interface RestaurantFormProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string; googleSheetUrl: string }) => void;
}

interface RestaurantFormData {
  name: string;
  googleSheetUrl: string;
}

const RestaurantForm: React.FC<RestaurantFormProps> = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm<RestaurantFormData>();

  const handleFormSubmit = (data: RestaurantFormData) => {
    onSubmit(data);
    reset();
    onClose();
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Добавить ресторан">
      <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            Название ресторана <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Введите название ресторана"
            {...register('name', { 
              required: 'Введите название ресторана',
              minLength: { value: 2, message: 'Название должно содержать минимум 2 символа' }
            })}
            className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
              errors.name ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Ссылка на Google таблицу <span className="text-red-500">*</span>
          </label>
          <input
            type="url"
            placeholder="https://docs.google.com/spreadsheets/d/..."
            {...register('googleSheetUrl', { 
              required: 'Введите ссылку на Google таблицу',
              pattern: {
                value: /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+/,
                message: 'Введите корректную ссылку на Google таблицу'
              }
            })}
            className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
              errors.googleSheetUrl ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.googleSheetUrl && (
            <p className="text-red-500 text-sm mt-1">{errors.googleSheetUrl.message}</p>
          )}
          <p className="text-sm text-gray-500 mt-1">
            Ссылка должна быть на Google таблицу с шаблоном для учета расходов
          </p>
        </div>

        <div className="flex space-x-3 pt-4">
          <Button type="submit" className="flex-1">
            Добавить ресторан
          </Button>
          <Button type="button" variant="secondary" onClick={handleClose} className="flex-1">
            Отмена
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default RestaurantForm;
